import styled from 'styled-components';
import ContentWrapper from '../ContentWrapper';
import { Flex } from '@rebass/grid';
import { FormattedMessage } from 'react-intl';
import { useRouter } from 'next/router';

const Footer = () => {
    const aboutUrls: Record<string, string> = {
        nl: 'https://qualitylodgings.com/nl/over',
        en: 'https://qualitylodgings.com/en/about',
        de: 'https://qualitylodgings.com/de/uber',
    };
    const generalUrls: Record<string, string> = {
        nl: 'https://qualitylodgings.com/nl/centrale-boekingsvoorwaarden',
        en: 'https://qualitylodgings.com/en/Central-Booking-Conditions',
        de: 'https://qualitylodgings.com/de/zentralen-buchungsbedingungen',
    };
    const faqUrls: Record<string, string> = {
        nl: 'https://qualitylodgings.com/nl/veelgestelde-vragen-Quality-Lodgings',
        en: 'https://qualitylodgings.com/en/frequently-asked-questions-Quality-Lodgings',
        de: 'https://qualitylodgings.com/de/h%C3%A4ufig-gestellte-Fragen-Quality-Lodgings',
    };
    const privacyUrls: Record<string, string> = {
        nl: 'https://qualitylodgings.com/nl/privacybeleid',
        en: 'https://qualitylodgings.com/en/privacy',
        de: 'https://qualitylodgings.com/de/datenschutzerklarung',
    };

    const { locale } = useRouter();

    const currentLocale = locale ?? 'nl';
    return (
        <Container>
            <StyledContentWrapper>
                <Flex pt={[null, '3.2rem']}>
                    <FooterNav>
                        <FooterColumn>
                            <div>
                                <FooterTitle>
                                    <FormattedMessage defaultMessage="Informatie" />
                                </FooterTitle>
                                <li>
                                    <a href={aboutUrls[currentLocale]}>
                                        <FormattedMessage defaultMessage="Over ons" />
                                    </a>
                                </li>
                                <li>
                                    <a href={generalUrls[currentLocale]}>
                                        <FormattedMessage defaultMessage="Algemene boekingsvoorwaarden" />
                                    </a>
                                </li>
                                <li>
                                    <a href={faqUrls[currentLocale]}>
                                        <FormattedMessage defaultMessage="Veelgestelde vragen" />
                                    </a>
                                </li>
                                <li>
                                    <a href={privacyUrls[currentLocale]}>
                                        <FormattedMessage defaultMessage="Privacy- en cookiebeleid" />
                                    </a>
                                </li>
                            </div>
                        </FooterColumn>
                        <FooterColumn>
                            <div>
                                <FooterTitle style={{ marginBottom: '0.6rem' }}>
                                    <FormattedMessage defaultMessage="Contact" />
                                </FooterTitle>
                                <p>
                                    <a href="mailto:bookings@qualitylodgings.com">bookings@qualitylodgings.com</a>
                                    <br />
                                    <a href="tel:+31(0)850207733">+31 (0)85 020 77 33</a>
                                    <br />
                                </p>
                            </div>
                        </FooterColumn>
                    </FooterNav>
                </Flex>
            </StyledContentWrapper>
        </Container>
    );
};

export default Footer;

const StyledContentWrapper = styled(ContentWrapper)`
    @media screen and (max-width: ${({ theme }) => theme.mediaQueries.m}) {
        padding: 0;
        margin-bottom: 0;
    }
`;

const Container = styled.div`
    margin-top: 2rem;
    padding-bottom: 10rem;
    background-color: white;
    border-top: 1px solid black;
`;

const FooterNav = styled.nav`
    display: flex;
    width: 100%;

    @media screen and (max-width: ${({ theme }) => theme.mediaQueries.s}) {
        flex-direction: column;
    }
`;

const FooterColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    color: black;
    align-items: center;
    text-align: left;

    @media screen and (max-width: ${({ theme }) => theme.mediaQueries.s}) {
        text-align: center;
    }

    @media screen and (min-width: ${({ theme }) => theme.mediaQueries.l}) {
        .grid {
            display: grid;
            grid-template-columns: 20% 25% 40%;
        }
    }

    a {
        color: ${({ theme }) => theme.colors.neutral['100']};
        text-decoration: none;
        font-size: 16px;
    }
`;

const FooterTitle = styled.h2`
    color: ${({ theme }) => theme.colors.neutral['100']};
    margin-bottom: 3rem;
`;
